<template>
  <component
    :is="tag"
    :class="computedClass"
    draggable="true"
    @dragstart="onDragStart"
    @dragend="onDragEnd"
  >
    <slot></slot>
  </component>
</template>

<script>
let dragIdCounter = 0;
if (!window.__dragTransferDataMap) {
  window.__dragTransferDataMap = {};
}

export default {
  name: 'DragDrop',
  props: {
    transferData: {
      type: [Object, String, Number, Array],
      default: null
    },
    tag: {
      type: String,
      default: 'span'
    }
  },
  data() {
    return {
      isDragging: false,
      dragId: null
    };
  },
  computed: {
    computedClass() {
      return {
        'drag-dragging': this.isDragging
      };
    }
  },
  methods: {
    onDragStart(e) {
      this.isDragging = true;
      this.dragId = String(++dragIdCounter);
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('application/json', JSON.stringify(this.transferData));
      e.dataTransfer.setData('text/drag-id', this.dragId);
      window.__dragTransferDataMap[this.dragId] = this.transferData;
      this.$emit('dragstart', this.transferData);
    },
    onDragEnd() {
      this.isDragging = false;
      if (this.dragId) {
        delete window.__dragTransferDataMap[this.dragId];
        this.dragId = null;
      }
      this.$emit('dragend');
    }
  }
};
</script>
